import React, { useState } from "react";
import { toast } from "react-toastify";

export default function FormRenouvellement({
  setValidResponse,
  validResponse,
  setFormData,
  formData,
  handleTrimValue,
  urlAPI,
  ville,
  page,
}) {
  const [classError, setClassError] = useState("");

  const jsonData = (e) => {
    const { value, name } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (
      e.target.classList.contains("radio-group") ||
      e.target.classList.contains("select-group")
    ) {
      document
        .querySelectorAll("." + e.target.getAttribute("datagroup") + "-group")
        .forEach((element) => {
          formData[element.name] = "";
          element.classList.replace("is-invalid", "is-valid");
        });
    }
  };

  const inputFocus = () => {
    const inputs = document.querySelectorAll(".renouvellement-group");
    inputs.forEach((element) => {
      if (element.value !== "") {
        setClassError("");
      }
    });
  };

  const fetchData = async () => {
    let myHeaders = {
      "Content-Type": "application/json",
    };
    const response = await fetch(urlAPI.path_renouvel, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: myHeaders,
    });
    const data = await response.json();
    if (data.code === "403") {
      setClassError("renouvellement-error");
      setValidResponse(false);
      toast.error(
        "Aucune correspondance avec votre Numéro d'autorisation et/ou votre Nom de bénéficiaire"
      );
      document.querySelectorAll(".renouvellement-group").forEach((input) => {
        setFormData((prev) => {
          const newFormData = { ...prev };
          delete newFormData[input.name];
          return newFormData;
        });
      });
    } else {
      setClassError("renouvellement-valid");
      setValidResponse(true);
      setFormData((prev) => ({
        ...prev,
        ProAutorisationPrec: formData.ProAutorisationPrec,
        nomTiers: formData.nomTiers,
        prenomTiers: formData.prenomTiers,
        ImmLocaliteAdr: ville,
      }));
      document.querySelectorAll(".renouvellement-group").forEach((input) => {
        input.setAttribute("disabled", true);
      });
      toast.success("Correspondance validée avec succès");
      document.querySelectorAll(".validation").forEach((input) => {
        if (input.classList.contains("btn")) {
          input.classList.add("d-none");
        } else if (input.classList.contains("alert")) {
          input.classList.remove("d-none");
        }
        input.innerHTML = `Vous demandez un renouvellement pour le local ce situant à l'adresse :<br/>${data.adresse}`;
      });
      document.querySelector(".support-message").classList.remove("d-none");
    }
  };

  //** Pour faire un test sans appel API */
  // const fetchData = () => {
  //   if (
  //     formData.ProAutorisationPrec === "test" &&
  //     formData.nomTiers === "test" &&
  //     formData.prenomTiers === "test"
  //   ) {
  //     setClassError("renouvellement-valid");
  //     setValidResponse(true);
  //     setFormData((prev) => ({
  //       ...prev,
  //       ProAutorisationPrec: formData.ProAutorisationPrec,
  //       nomTiers: formData.nomTiers,
  //       prenomTiers: formData.prenomTiers,
  //     }));
  //     document.querySelectorAll(".renouvellement-group").forEach((input) => {
  //       input.setAttribute("disabled", true);
  //     });
  //     toast.success("Correspondance validée avec succès");
  //   } else {
  //     setClassError("renouvellement-error");
  //     setValidResponse(false);
  //     setFormData((prev) => ({
  //       ...prev,
  //       ProAutorisationPrec: "",
  //       nomTiers: "",
  //       prenomTiers: "",
  //     }));
  //     toast.error(
  //       "Aucune correspondance avec votre Numéro d'autorisation et/ou votre Nom de bénéficiaire"
  //     );
  //   }
  // };

  return (
    <div className="background--warning p-4 mt-5 pb-0">
      <div className="col-12 position-relative">
        <label htmlFor="ProAutorisationPrec" className="form-label">
          N° de la précédente autorisation&nbsp;:&nbsp;
          <span className="text-danger">*</span>
        </label>
        <input
          className={`form-control renouvellement-group ProActivite-group ProPremierCU-group getLabel ${classError}`}
          type="text"
          placeholder="Ex: CU-ville-000000-00000"
          name="ProAutorisationPrec"
          id="ProAutorisationPrec"
          value={formData.ProAutorisationPrec || ""}
          onChange={jsonData}
          onInput={inputFocus}
          onBlur={handleTrimValue}
          required
          autoComplete="nope"
        />
      </div>
      <div className="col-12 position-relative pt-4">
        <label htmlFor="nomTiers" className="form-label">
          Nom du bénéficiaire de l'autorisation&nbsp;:&nbsp;
          <span className="text-danger">*</span>
        </label>
        <input
          className={`form-control renouvellement-group ProActivite-group ProPremierCU-group getLabel ${classError}`}
          type="text"
          name="nomTiers"
          id="nomTiers"
          value={formData.nomTiers || ""}
          onChange={jsonData}
          onInput={inputFocus}
          onBlur={handleTrimValue}
          required
          autoComplete="nope"
        />
      </div>
      <div className="col-12 position-relative pt-4">
        <label htmlFor="prenomTiers" className="form-label">
          Prénom du bénéficiaire de l'autorisation&nbsp;:&nbsp;
          <span className="text-danger">*</span>
        </label>
        <input
          className={`form-control renouvellement-group ProActivite-group ProPremierCU-group getLabel ${classError}`}
          type="text"
          name="prenomTiers"
          id="prenomTiers"
          value={formData.prenomTiers || ""}
          onChange={jsonData}
          onInput={inputFocus}
          onBlur={handleTrimValue}
          required
          autoComplete="nope"
        />
      </div>
      <div className="d-flex justify-content-center mt-4 mb-4">
        {page < 5 && (
          <button
            type="button"
            className="btn btn-warning btn-md validation"
            onClick={fetchData}
          >
            Vérifier votre dossier
          </button>
        )}
        <div className="alert alert-success validation d-none text-center"></div>
      </div>
      <div className="mt-4 mb-2 support-message d-none">
        <span className="fs-6">
          * Si l'adresse ne correspond pas, veuillez contacter le support:{" "}
          <a href="mailto:support@touriz.fr">support@touriz.fr</a>
        </span>
      </div>
    </div>
  );
}
